export default __webpack_public_path__ + "static/media/lernantino.32d6fef3.svg";